import { getNinjaConfig } from '../config/ninja';
import { Channel } from '../const';
import * as androidBridge from './androidBridge';
import * as iosBridge from './iosBridge';

/**
 * Checks if the native handlers exist in window and returns the appropriate function
 * @param {string} fn
 * @returns {Function?}
 */
export function getNativeFn(fn) {
  let fnToInvoke;

  if (getNinjaConfig().platform === Channel.Android) {
    fnToInvoke = androidBridge[fn];
  } else if (getNinjaConfig().platform === Channel.iOS) {
    fnToInvoke = iosBridge[fn];
  }

  if (typeof fnToInvoke !== 'function') {
    console.log(`Function ${fn} not defined in native bridge!`);
    return null;
  }

  return fnToInvoke;
}

/**
 *
 * @param {'trackView' | 'trackEvent' | 'getVariant' | 'isFeatureEnabled' | 'trackEventDelayed' | 'flushDelayed'} fn
 * @param  {...any} args
 * @returns
 */
export function nativeHandlerFn(fn, ...args) {
  const fnToInvoke = getNativeFn(fn);

  if (fnToInvoke) {
    return fnToInvoke(...args);
  }

  return null;
}
